export default {
    // 不正常行李申报校验
    async applyAbnormalLuggageCheck(params) {
        let actiontype = 'applyAbnormalLuggageCheck';
        return await this.fetch(actiontype, params);
    },
    // 不正常行李申报
    async applyAbnormalLuggage(params) {
        let actiontype = 'applyAbnormalLuggage';
        return await this.fetch(actiontype, params);
    },
    // 获取机场失物招领服务电话
    async getLostAndFoundServicePhone(params) {
        let actiontype = 'getLostAndFoundServicePhone';
        return await this.fetch(actiontype, params);
    },
    // 获取我的申报详情
    async getMyAbnormalLuggageDetail(params) {
        let actiontype = 'getMyAbnormalLuggageDetail';
        return await this.fetch(actiontype, params);
    },
    // 获取我的申报列表
    async getMyAbnormalLuggageList(params) {
        let actiontype = 'getMyAbnormalLuggageList';
        return await this.fetch(actiontype, params);
    },
    // 获取行李支付订单详情
    async getLuggageOrderDetailByToken(params) {
        let actiontype = 'getLuggageOrderDetailByToken';
        return await this.fetch(actiontype, params);
    },
}


// WEBPACK FOOTER //
// ./src/interfaces/modules/luggage.js